<template lang='pug'>
v-dialog(scrollable max-width='400px' v-model='dialog' persistent lazy)
  v-card(class='combo-card')
    v-card-title
      v-text-field(
        :loading='isLoading'
        ref='search'
        @input='onSearch'
        prepend-inner-icon='search'
        label='Поиск'
        hide-details
        clearable
      )
    v-card-text(style='height: 300px')
      //-
      v-list(v-if='multiple' two-line class='multiple-select')
        v-list-tile(v-for='item in list' :key='item.id')
          v-list-tile-action
            v-checkbox(:value='item.id' @change='toggleMultipleSelect(item)' color='primary')
          v-list-tile-content
            v-list-tile-title {{ item.full_name }}
            v-list-tile-sub-title Должность / отдел
      //-
      v-list(v-else two-line class='multiple-select')
        v-radio-group(v-model='selected' )
          v-radio(v-for='item in list' :key='item.id' :value='item.id' color='primary' :label="item.full_name")

    v-card-actions
      v-spacer
      v-btn(@click='$emit("close")' flat) Отмена
      v-btn(
        flat
        :disabled='disabled'
        color='primary'
        @click='$emit("select", multiple ? selectedMult : selectedOnce)'
      ) Ok
</template>

<script>
import http from '@/http'
import { debounce, find, xor } from 'lodash'

export default {
  props: ['dialog', 'multiple'],

  data: () => ({
    search: null,
    selectedMult: [],
    count: 50,
    selected: null,
    isLoading: false,
    list: []
  }),

  mounted() {
    if (this.dialog) {
      this.fetch()
    }
  },

  methods: {
    debouncedFetch: debounce(function() {
      let { search, count } = this
      this.fetchList({ search, count })
    }, 250),

    async fetchList(params) {
      try {
        this.isLoading = true
        this.list = (await http.get('/admin/managers', { params })).data.data
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить список менеджеров')
      } finally {
        this.isLoading = false
      }
    },

    toggleMultipleSelect(item) {
      if (!item) return
      this.selectedMult = xor(this.selectedMult, [item])
    },

    onSearch(search) {
      this.search = search
    }
  },

  computed: {
    disabled() {
      return !(this.selectedOnce || this.selectedMult.length)
    },

    selectedOnce() {
      return find(this.list, {
        id: this.selected
      })
    }
  },

  watch: {
    dialog(opened) {
      if (opened) {
        this.debouncedFetch()

        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      } else {
        this.list = []
        this.selected = null
        this.selectedMult = []
      }
    },

    search: 'debouncedFetch'
  }
}
</script>

<style scoped>
.combo-card {
  height: 100%;
}
.multiple-select >>> .v-list__tile {
  padding: 0;
}
.multiple-select >>> .v-input {
  flex: 0;
}
<style scoped > .combo-card {
  height: 100%;
}
.combo-card >>> .v-list__tile__sub-title,
.combo-card >>> .v-list__tile__title {
  white-space: unset;
}
</style>
